import { render, staticRenderFns } from "./ModalRecFacial.vue?vue&type=template&id=7dabe0f9&scoped=true"
import script from "./ModalRecFacial.vue?vue&type=script&lang=js"
export * from "./ModalRecFacial.vue?vue&type=script&lang=js"
import style0 from "./ModalRecFacial.vue?vue&type=style&index=0&id=7dabe0f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dabe0f9",
  null
  
)

export default component.exports